import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PhotoUpload from '../../../../components/PhotoUpload';
import TextInputNoob from '../../../../components/input/TextInputNoob';
import TextAreaEditor from '../../../../components/TextAreaEditor';
import { withRouter, useRouteMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { objectHasValue } from '../../../../helpers/helpers';
import moment from 'moment';
import { editEvent } from '../action';
import Button from '../../../../components/Button';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import './style.scss';

const CreateEvents = ({ history, uploadPhoto, editEventProgress, editEvent }) => {
  const match = useRouteMatch();
  const { id } = match.params;
  const listEvent = history.location.state;
  let detailEvent;
  listEvent.forEach((event) => {
    if (event._id === id) {
      detailEvent = event;
    }
  });
  const [textValue, setTextValue] = useState(detailEvent.description);
  const [titleValue, setTitleValue] = useState(detailEvent.title);
  const [shortDesc, setShortDesc] = useState(detailEvent.excerpt);
  const [price, setPrice] = useState(detailEvent.admission_fee);
  const [contact, setContact] = useState(detailEvent.phone);
  const [location, setLocation] = useState(detailEvent.address);
  const [startDate, setStartDate] = useState(
    moment(detailEvent.datetime).format('DD/MM/YYYY kk:mm')
  );
  const [canRegister, setCanRegister] = useState(detailEvent.can_register);
  const defaultForm = {
    title: titleValue,
    image_url: objectHasValue(uploadPhoto.data)
      ? uploadPhoto.data.data.url
      : detailEvent.image_url,
    excerpt: shortDesc,
    description: textValue,
    currency: 'USD',
    admission_fee: price,
    datetime: moment(startDate._d).format('YYYY-MM-DDTHH:mm:ssZ'),
    address: location,
    place: location,
    can_register: canRegister == 'true' ? true : false,
    location: '40.6971494,-74.25987',
    phone: contact,
    contact: {
      address: location,
      phone: contact
    }
  };

  const submitEvent = () => {
    editEvent(id, defaultForm);
  };

  if (editEventProgress.status === 'resolve') {
    window.location = '/admin/events';
  }

  return (
    <div className='create-events'>
      <div className='header'>EDIT ACARA/PAMERAN</div>
      <div className='content'>
        <PhotoUpload initialImg={detailEvent.image_url} />
        <span style={{ height: 10, display: 'inline-block' }} />
        <span style={{ height: 5, display: 'inline-block' }} />
        <TextInputNoob
          label='Title *'
          value={titleValue}
          action={setTitleValue}
          placeholder='Masukkan judul kegiatan/pameran'
        />
        <TextInputNoob
          label='Deskripsi singkat tentang kegiatan *'
          value={shortDesc}
          action={setShortDesc}
          placeholder='Masukkan deskripsi'
        />
        <div className='div-2 div-wrap'>
          <div className='div-2 div-wrap-1'>
            <TextInputNoob
              value={price}
              label='Price * (Isikan 0 apabila gratis)'
              action={setPrice}
              placeholder='$ 0'
            />
            <TextInputNoob
              label='Contact *'
              action={setContact}
              value={contact}
              placeholder='ex: +1 (232) 8288228'
            />
          </div>
          <div className='div-wrap-2'>
            <TextInputNoob
              label='Location *'
              value={location}
              action={setLocation}
              placeholder='ex: New York'
            />
          </div>
        </div>
        <div className='div-2'>
          <div className='div-wrap-2 date-input' style={{ paddingRight: 30 }}>
            <div className='label'>Start Date *</div>
            {/* <input
              type='datetime-local'
              className='start'
              value={startDate}
              id='start'
              name='start'
              onChange={(e) => setStartDate(e.target.value)}
            /> */}
            <Datetime
              initialValue={startDate}
              initialViewDate={startDate}
              onChange={(e) => setStartDate(e)}
            />
          </div>
          <div className='div-wrap-2 date-input' style={{ width: 300 }}>
            <div className='label'>User Can Register *</div>
            <select
              name='can_register'
              value={canRegister}
              onChange={(e) => setCanRegister(e.target.value)}
            >
              <option value='true'>Yes</option>
              <option value='false'>No</option>
            </select>
          </div>
        </div>
        <span style={{ height: 5, display: 'inline-block' }} />
        <TextAreaEditor value={textValue} label='Deskripsi *' action={setTextValue} />
        <span style={{ height: 5, display: 'inline-block' }} />
        <div className='btn-wrap'>
          <Button color='link' type='button' onClick={() => history.goBack()}>
            Cancel
          </Button>
          <Button
            color='primary'
            type='submit'
            className='pass-btn'
            onClick={() => submitEvent()}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

CreateEvents.propTypes = {
  history: PropTypes.object,
  uploadPhoto: PropTypes.object,
  editEventProgress: PropTypes.object,
  editEvent: PropTypes.func
};

const mapStateToProps = (state) => ({
  uploadPhoto: {
    status: state.uploadPhotoGeneral.status,
    error: state.uploadPhotoGeneral.error,
    data: state.uploadPhotoGeneral.data
  },
  editEventProgress: {
    status: state.editEventReducerAdmin.status
  }
});

export default compose(connect(mapStateToProps, { editEvent }), withRouter)(CreateEvents);
